import { render, staticRenderFns } from "./ManageBlackList.vue?vue&type=template&id=03f8d0bc&scoped=true"
import script from "./ManageBlackList.vue?vue&type=script&lang=js"
export * from "./ManageBlackList.vue?vue&type=script&lang=js"
import style0 from "./ManageBlackList.vue?vue&type=style&index=0&id=03f8d0bc&prod&scoped=true&lang=css"
import style1 from "./ManageBlackList.vue?vue&type=style&index=1&id=03f8d0bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f8d0bc",
  null
  
)

export default component.exports